import { KartenMarkdown } from '../lib/markdown.jsx'

/**
 * Die Karte selbst: Frage, Antwort, Zusatz.
 * Größen und Gewichte stehen in DESIGN.md (Frage 26/1.35/500,
 * Antwort 21/1.55/400) und kommen als Tokens aus lernen.css.
 *
 * Die Antwort blendet ein und steigt dabei 8px auf — die einzige Stelle mit
 * choreografierter Bewegung. Kein 3D-Dreher.
 *
 * Eine Rückwärts-Abfrage trägt einen Streifen und ein ↻ in der Rinne links.
 * Kein Wort: die Zeile Höhe gehört auf dem Telefon der Frage. Die Marke gehört
 * zur Karte, nicht zum Rahmen — die fünf Dinge aus DESIGN.md bleiben fünf.
 */
export function Kartentext({ karte, umgedreht }) {
  return (
    <div class={`kartentext ${karte.rueckwaerts ? 'kartentext--rueckwaerts' : ''}`}>
      {karte.rueckwaerts ? (
        <>
          <span class="visuell-versteckt">Rückwärts gefragt.</span>
          <span class="kartentext__richtung" aria-hidden="true">
            ↻
          </span>
        </>
      ) : null}

      <KartenMarkdown class="kartentext__frage" text={karte.front_md} />

      {umgedreht ? (
        <div class="kartentext__antwort-block">
          <hr class="kartentext__trenner" />
          <KartenMarkdown class="kartentext__antwort" text={karte.back_md} />
          {karte.back_extra_md ? (
            <KartenMarkdown class="kartentext__zusatz" text={karte.back_extra_md} />
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
